import axios from "axios";
import success from "../interceptors/success";
import failure from "../interceptors/failure";
import process from "shelljs";

const api = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    "Content-type": "application/json"
  }
});

// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('jwt.token')
//   config.headers.Authorization = `Bearer ${token}`
//   return config
// })

api.interceptors.response.use(success, failure)

export default api



// WEBPACK FOOTER //
// ./src/service/http-common.js